import React, { createContext, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Accueil from "./pages/Accueil";
import Services from "./pages/Services";
import "./style/index.scss";
import Realisations from "./pages/Realisations";
import Ensavoirplus from "./pages/Ensavoirplus";
import Partenaires from "./pages/Partenaires";

export const LoadContext = createContext();

const App = () => {
  const [load, setLoad] = useState(false);
  return (
    <LoadContext.Provider value={{ load, setLoad }}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Accueil />}></Route>
          <Route path="/Services" element={<Services />}></Route>
          <Route path="/Realisations" element={<Realisations />}></Route>
          <Route path="/Ensavoirplus" element={<Ensavoirplus />}></Route>
          <Route path="/Partenaires" element={<Partenaires />}></Route>
          <Route path="*" element={<Accueil />}></Route>
        </Routes>
      </BrowserRouter>
    </LoadContext.Provider>
  );
};

export default App;
